import type { ChecklistItem, ChecklistResponse } from '@/domain/shift-handover/types';

interface Props {
  item: ChecklistItem;
  response: ChecklistResponse | undefined;
  onChange: (next: ChecklistResponse) => void;
  highlightIncomplete: boolean;
}

export default function ChecklistItemRow({ item, response, onChange, highlightIncomplete }: Props) {
  const answer = response?.answer ?? null;

  function setAnswer(next: 'sim' | 'nao') {
    onChange({ item_id: item.id, answer: next });
  }

  return (
    <div
      className={`rounded-lg border p-3 transition ${
        highlightIncomplete
          ? 'border-red-500 bg-red-500/5'
          : 'border-jf-border bg-jf-surface2'
      }`}
    >
      <div className="flex items-start gap-3">
        <span className="mt-0.5 text-xs text-jf-dim font-bold">{item.order_index}.</span>
        <div className="flex-1 text-sm text-white">{item.label}</div>
        <div className="flex gap-1.5 shrink-0">
          <RadioPill label="Sim" selected={answer === 'sim'} onClick={() => setAnswer('sim')} />
          <RadioPill label="Não" selected={answer === 'nao'} onClick={() => setAnswer('nao')} />
        </div>
      </div>
    </div>
  );
}

interface RadioPillProps {
  label: string;
  selected: boolean;
  onClick: () => void;
}

function RadioPill({ label, selected, onClick }: RadioPillProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`rounded-md px-2.5 py-1 text-xs font-bold transition ${
        selected
          ? 'border border-jf-yellow bg-jf-yellow/20 text-jf-yellow'
          : 'border border-jf-border bg-jf-surface text-jf-muted hover:border-jf-yellow/50'
      }`}
    >
      {label}
    </button>
  );
}
